export enum ActivityType {
  All = 'all',
  Marketing = 'Marketing',
  Sales = 'Sales',
  Anonymous = 'Anonymous',
  Opportunity = 'Opportunity',
}
